module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n    Humidity Graph\n  ")]), _vm._v(" "), _c('humidity-ranges'), _vm._v(" "), _c('chart', {
    ref: "humidityChart",
    attrs: {
      "options": _vm.line
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17b73138","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HumidityGraph.vue
// module id = 370
// module chunks = 1